import { push } from 'react-router-redux';

export const welcome = {
  title: 'Help: Welcome',
  run: dispatch => dispatch(push('/welcome')),
};



// WEBPACK FOOTER //
// ./src/lib/commands/welcome.js